/**
 * pdf.js uses Promise.withResolvers which is not supported in older browsers.
 */

// Check if Promise.withResolvers is not available and add polyfill
if (typeof Promise.withResolvers === 'undefined') {
  // @ts-expect-error This does not exist outside of polyfill which this is doing
  Promise.withResolvers = function () {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

// Export the polyfill function for backwards compatibility
export const promiseWithResolversPolyfill = () => {
  // The polyfill is already applied above when this module is imported
};
